// Pixi-applikationen: WebGL som standard, WebGPU med ?renderer=webgpu. DPR højst 2.
// Vi tegner selv i requestAnimationFrame (autoStart: false), så simulation og tegning følges ad.

import { Application } from 'pixi.js';
import { C } from './palette';

export type RendererPref = 'webgl' | 'webgpu';

export interface AppOptions {
  renderer: RendererPref;
  resolution: number;
  onContextRestored: () => void;
}

export function maxResolution(): number {
  return Math.min(2, Math.max(1, window.devicePixelRatio || 1));
}

export async function createApp(host: HTMLElement, opts: AppOptions): Promise<Application> {
  const app = new Application();
  await app.init({
    preference: opts.renderer,
    resizeTo: host,
    antialias: true,
    background: C.sea,
    resolution: opts.resolution,
    autoDensity: true,
    autoStart: false,
    sharedTicker: false,
    powerPreference: 'high-performance',
  });
  app.ticker.stop();
  const canvas = app.canvas;
  canvas.setAttribute('aria-hidden', 'true');
  canvas.addEventListener('webglcontextlost', (e) => e.preventDefault());
  canvas.addEventListener('webglcontextrestored', () => {
    // Pixi genskaber sine egne ressourcer først; derefter maler vi teksturerne igen.
    setTimeout(opts.onContextRestored, 0);
  });
  host.appendChild(canvas);
  return app;
}
